import { combineReducers } from "redux";
import { backendAccessReducer } from "./components/backend-access";
import { errorHandlerReducer } from "./components/main-layout/components/error-handler-store";
import { aboutDialogReducer } from "./components/main-layout/components/about-dialog/about-dialog-store";
export const reducer = combineReducers({
    aboutDialog: aboutDialogReducer,
    errorHandler: errorHandlerReducer,
    backendAccess: backendAccessReducer
});
